export interface FeatureFlags {
  readonly annotations: boolean
  readonly readspeaker: boolean
}

export const defaultFeatureFlags: FeatureFlags = {
  annotations: true,
  readspeaker: true,
};
